import { Flex } from "@chakra-ui/react";
import Button from "../Button/Button";
import CSS from "./styles.module.css";

// Animate on Scroll
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";

const CTA = ({
	heading,
	buttonText,
	buttonIcon,
	link,
	linkTarget,
	onClick,
	small,
}) => {
	useEffect(() => {
		AOS.init({ duration: 500, delay: 0 });
	}, []);

	return (
		<Flex width="100%" justifyContent="center" data-aos="fade-up">
			<div className={`${CSS.CTA} ${small && CSS.CTAsmall}`}>
				<h3>{heading}</h3>
				<a href={link} target={linkTarget}>
					<Button variant="HeroButton" leftIcon={buttonIcon} onClick={onClick}>
						{buttonText}
					</Button>
				</a>
			</div>
		</Flex>
	);
};

export default CTA;
